import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Lock } from "lucide-react";

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      onLogin && onLogin();
      navigate("/admin/leads");
    } catch (err) {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0e13] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-8">
          <img src="/assets/logo.png" alt="logo" className="w-12 h-12 object-contain bg-white rounded-xl p-1.5" />
          <div>
            <div className="text-white font-display font-bold text-lg leading-tight">Classic Interior</div>
            <div className="text-[#2f9fe6] text-xs tracking-[0.2em]">CMS</div>
          </div>
        </div>
        <form onSubmit={submit} className="bg-[#141a22] rounded-2xl p-8 border border-white/5">
          <div className="w-12 h-12 rounded-xl bg-[#2f9fe6]/15 flex items-center justify-center mb-6">
            <Lock className="w-6 h-6 text-[#2f9fe6]" />
          </div>
          <h1 className="text-white font-display text-2xl font-semibold mb-1">Welcome back</h1>
          <p className="text-[#6b7683] text-sm mb-6">Sign in to manage your website.</p>
          {error && <div className="mb-4 text-sm text-red-400 bg-red-500/10 px-4 py-2.5 rounded-lg">{error}</div>}
          <label className="block text-sm text-[#9aa4af] mb-1.5">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mb-4 px-4 py-3 rounded-lg bg-[#0b0e13] border border-white/10 text-white focus:border-[#2f9fe6] outline-none transition-colors" placeholder="admin@classic-interior.com" />
          <label className="block text-sm text-[#9aa4af] mb-1.5">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mb-6 px-4 py-3 rounded-lg bg-[#0b0e13] border border-white/10 text-white focus:border-[#2f9fe6] outline-none transition-colors" placeholder="••••••••" />
          <button type="submit" disabled={loading} className="w-full py-3 rounded-lg bg-[#2f9fe6] text-white font-semibold hover:bg-[#1f82c7] transition-colors disabled:opacity-60">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
